import { useState } from "react";
import { useForm } from "../../common/viewmodels/DefaultVM";
import { FileCategory, FileType, UploadPictureModel } from "../models/PictureModel";

export function useAddPictureVM() {
    const [loading, setLoading] = useState<boolean>(false);

    const {
        form,
        setForm,
        resetForm,
        setField
    } = useForm<UploadPictureModel>({
        id: 0,
        category: FileCategory.normal,
        type: FileType.image,
        isPrimary: false,
        order: 0,
        collageOrder: 99,
        length: 0,
        file: undefined,
        bytes: undefined,
        imageUrl: undefined
    });

    return {
        loading,
        setLoading,
        form,
        setForm,
        resetForm,
        setField
    };
}